enum Actions {
  // action types
  ADD_BODY_CLASSNAME = "addBodyClassName",
  REMOVE_BODY_CLASSNAME = "removeBodyClassName",
  ADD_BODY_ATTRIBUTE = "addBodyAttribute",
  REMOVE_BODY_ATTRIBUTE = "removeBodyAttribute",
  ADD_CLASSNAME = "addClassName",
  VERIFY_AUTH = "verifyAuth",
  LOGIN = "login",
  LOGOUT = "logout",
  REGISTER = "register",
  FORGOT_PASSWORD = "forgotPassword",
  SET_THEME_MODE_ACTION = "setThemeModeAction",
  SEND_OTP = "sendOtp",
  ACTIVE_MOBILE = "activeMobile",
  RESEND_ACTIVE_CODE = "resendActiveCode",
  GET_SERVICES = "getServices",
  ADD_SERVICE = "addService",
  EDIT_SERVICE = "editService",
  GET_SERVICE = "getService",
  ADD_RANGE_PRICE = "addRangePrice",
  GET_RANGE_PRICE = "getRangePrice",

  GET_USERS = "getUsers",
  GET_USER = "getUser",
  BLOCK_USER = "blockUser",
  UNBLOCK_USER = "unblockUser",
  ADD_USER = "addUser",
  EDIT_USER = "editUser",
  EDIT_PROFILE = "editProfile",
  GET_DISCOUNTS = "getDiscounts",
  ADD_DISCOUNT = "addDiscount",
  GET_INVOICES = "getInvoices",
  GET_INVOICE = "getInvoice",
  EDIT_INVOICE = "editInvoice",
  ACCEPT_INVOICE = "acceptInvoice",
  DOWNLOAD_INVOICE = "downloadInvoice",
  GET_LOGS = "getLogs",
  CHANGE_LOG_STATUS = "changeLogStatus",
  GET_SETTING = "getSetting",
  SAVE_SETTING = "saveSeting",
  GET_CHANNELS = "getChannels",
  END_COOPERATION = "endCooperation",
  ACCEPT_CHANNEL = "acceptChannel",
  REJECT_CHANNEL = "rejectChannel",
  PRINT_CONTRACT = "printCntract",
  GET_YOUTUBE_INVOICES = "getYoutubeInvoices",
  GET_YOUTUBE_INVOICE = "getYoutubeInvoice",
  ADD_YOUTUBE_INVOICE = "addYoutubeInvoice",
  GET_TICKETS = "getTickets",
  GET_DEPARTMENTS = "getDepartments",
  EDIT_DEPARTMENT = "editDepartment",
  ADD_DEPARTMENT = "addDepartment",
  ANSWER = "answer",
  GET_TICKET = "getTicket",
  DOWNLOAD_ATTACHMENT = "downloadAttachment",
  CLOSE_TICKET = "closeTicket",
  GET_SERVICES_TYPE = "getServicesType",
  GET_KEYWORD_PLANNERS = "getKeywordPlanners",
  GET_KEYWORD_PLANNER = "getKeywordPlanner",
  ADD_KEYWORD_PLANNER = "addKeywordPlanner",
  EDIT_KEYWORD_PLANNER = "editKeywordPlanner",
  OPERATORS = "operators",
  EXPORT_INVOICE = "exportInvoice",
  REJECT_INVOICE = "rejectInvoice",
  GET_KEYWORD_PLANNERS_FOR_SELECTOR = "getKeywordPlannerForSelector",
  GET_SERVICES_FOR_SELECTOR = "getServicesForSelector",
  SEARCH_USERS = "searchUsers",
  ADD_MANUAL_INVOICE = "addManualInvoice",
  GET_ACCOUNTS_NUMBER = "getAccountsNumber",
  GET_ACCOUNT_NUMBER = "getAccountNumber",
  ADD_ACCOUNT_NUMBER = "addAccountNumber",
  EDIT_ACCOUNT_NUMBER = "editAccountsNumber",
  GET_ALL_ACCOUNTS_NUMBER = "getAllAccountsNumber",
  GET_ACCOUNT_TRANSACTIONS = "getAccountTransactions",
  GET_ACCOUNT_TRANSACTION = "getAccountTransaction",
  ADD_ACCOUNT_TRANSACTION = "addAccountTransaction",
  EDIT_ACCOUNT_TRANSACTION = "editAccountTransaction",
  DELETE_ACCOUNT_TRANSACTION = "deleteAccountTransaction",
  GET_COUNTERPARTY_TRANSACTIONS = "getCounterpartyTransactions",
  UPDATE_COUNTERPARTY_TRANSACTION = "editCounterpartyTransaction",
  ADD_COUNTERPARTY_TRANSACTION = "addCounterpartyTransaction",
  GET_ALL_COUNTERPARTY_TRANSACTION = "getAllCounterpartyTransaction",
  DESTROY_COUNTERPARTY_TRANSACTION = "destroyCounterpartyTransaction",
  RESTORE_COUNTERPARTY_TRANSACTION = "restoreCounterpartyTransaction",
  GET_CURRENCY_RATE = "getCurrencyRate",
  GET_ACTIVITY_LOGS = "getActivityLogs",
}

enum Mutations {
  // mutation types
  SET_CLASSNAME_BY_POSITION = "appendBreadcrumb",
  PURGE_AUTH = "logOut",
  SET_AUTH = "setAuth",
  SET_ONE_USER = "setOneUser",
  SET_ERROR = "setError",
  SET_LAYOUT_CONFIG_PROPERTY = "setLayoutConfigProperty",
  RESET_LAYOUT_CONFIG = "resetLayoutConfig",
  OVERRIDE_LAYOUT_CONFIG = "overrideLayoutConfig",
  OVERRIDE_PAGE_LAYOUT_CONFIG = "overridePageLayoutConfig",
  SET_THEME_MODE_MUTATION = "setThemeModeMutation",
  SET_SERVICES = "setServices",
  SET_SERVICES_FOR_SELECTOR = "setServicesForSelector",
  SET_SERVICE = "setService",
  SET_RANGE_PRICE = "setRangePrice",

  SET_USERS = "setUsers",
  SET_DISCOUNTS = "setDiscounts",
  SET_INVOICES = "setInvoices",
  SET_INVOICE = "setInvoice",

  SET_LOGS = "setLog",
  SET_SETTING = "setSetting",
  SET_CHANNELS = "setChannels",
  SET_TICKETS = "setTickets",
  SET_DEPARTMENTS = "setDepartments",
  SET_TICKET = "setTicket",
  SET_SERVICES_TYPE = "setServicesType",
  SET_KEYWORD_PLANNERS = "setKeywordPlanners",
  SET_KEYWORD_PLANNER = "setKeywordPlanner",
  SET_OPERATORS = "setOperators",
  SET_KEYWORD_PLANNERS_FOR_SELECTOR = "setKeywordPlannersForSelector",
  SET_SEARCH_USERS = "setSearchUser",
  SET_ACCOUNTS_NUMBER = "setAccountsNumber",
  SET_ACCOUNT_NUMBER = "setAccountNumber",
  SET_ALL_ACCOUNTS_NUMBER = "setAllAccountsNumber",
  SET_ACCOUNT_TRANSACTIONS = "setAllAccountTransactions",
  SET_ACCOUNT_TRANSACTION = "setAccountTransaction",
  SET_COUNTERPARTY_TRANSACTIONS = "setCountryTransactions",
  SET_ALL_COUNTERPARTY_TRANSACTION = "setAllCountryTransactions",
  SET_CURRENCY_RATE = "setCurrencyRate",
  SET_ACTIVITY_LOGS = "setActivityLogs",
}

export { Actions, Mutations };
